<!--
    @修改人：黎柏祺
    @修改时间：2018-12-17
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 谢汉
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 日志组件管理页-topic配置
    -->
<template>
  <div class="topicConfig__content">
    <el-button type="primary" class="mb-base" @click="e_addTopic()" v-text="$t('logComponentManage.add')" v-g-rac="gRac('topicConfig_add')"></el-button>
    <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <dialog-form
      key="topicForm"
      :title="dialogTitle" 
      :size="1" 
      :label-size="2" 
      :visible.sync="dialogFormShow" 
      :model="dialogModel"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :cancel-fun="e_cancel"
      :confirm-fun="e_save">
    </dialog-form>
  </div>
</template>
<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import topicConfigBiz from '@/logic/systemSetting/topicConfigBiz.js'
  import dialogForm from '@/components/dialogForm'
  import validateConfig from '@/utils/validate'
  import { getKeyByValue } from '@/utils/tool'

  export default {
    mixins: [rac, dic, table],
    components: {
      dialogForm
    },
    props: ['siteCode'],
    data () {
      const that = this
      return {
        tableControl: [
          {
            label: that.$t('common.edit'),
            callback: that.e_addTopic,
            rac: () => that.gRac('topicConfig_amend')
          },
          {
            label: that.$t('common.delete'),
            callback: that.e_delete,
            rac: () => that.gRac('topicConfig_delete')
          }
        ],
        select_topic: {},
        select_server: {},
        dialogFormShow: false,
        dialogTitle: '',
        dialogModel: {},
        dialogData: [],
        dialogFormRule: {},
        isAmend: false,
        init: true
      }
    },
    methods: {
      async preInitTable () {
        await Promise.all([
          this.dGetDictionaryByCode('serverType'),
          this.dGetDictionaryByCode('topicType')
        ])
        this.select_server = this.dDictionary.serverType
        this.select_topic = this.dDictionary.topicType
        this.initTable()
        this.setDialogData()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'logComponentManage.table',
          head: ['topic', 'topicType', 'serverType', 'partitionNum', 'introduce'],
          requestFun: this.search,
          headOpt: {
            topicType: {
              formatter: 'Dictionary',
              formatterDic: this.dDictionary.topicType
            },
            serverType: {
              formatter: 'Dictionary',
              formatterDic: this.dDictionary.serverType
            }
          }
        })
      },
      setDialogData () {
        this.dialogData = [
          {
            label: this.$t('logComponentManage.topicCN'),
            key: 'topic',
            inputWidth: '200px'
          },
          {
            label: this.$t('logComponentManage.topicType'),
            key: 'topicType',
            inputWidth: '200px',
            type: 'select',
            select: this.dDictionary.topicType
          },
          {
            label: this.$t('logComponentManage.serverType'),
            key: 'serverType',
            type: 'select',
            select: this.dDictionary.serverType,
            inputWidth: '200px'
          },
          {
            label: this.$t('logComponentManage.partitionNum'),
            key: 'partitionNum',
            inputWidth: '200px',
            placeholder: this.$t('logComponentManage.numberTips'),
            type: 'number'
          },
          {
            label: this.$t('logComponentManage.introduce'),
            key: 'introduce',
            inputWidth: '200px'
          }
        ]
        const validatePass = (rule, value, callback) => {
          if (value % 1 !== 0) {
            callback(new Error(this.$t('logComponentManage.numberTips')))
          } else {
            callback()
          }
        }
        this.dialogFormRule = {
          topic: [{ ...validateConfig.common.notEmpty }],
          topicType: [{ ...validateConfig.common.notEmpty }],
          serverType: [{ ...validateConfig.common.notEmpty }],
          partitionNum: [{
            validator: validatePass, trigger: 'blur'
          }]
        }
      },
      search () {
        const reqData = { ...this.tPageInfo }
        reqData.siteCode = this.siteCode
        topicConfigBiz.getTopic(reqData).then((data) => {
          this.tData = data
        }).catch((err) => {
          console.error(err)
        })
      },
      e_addTopic (rowData) {
        this.dialogFormShow = true
        this.isAmend = rowData !== undefined
        this.dialogTitle = rowData !== undefined ? this.$t('logComponentManage.update') : this.$t('logComponentManage.add')
        if (rowData) {
          this.dialogModel = {
            topic: rowData.topic,
            topicType: getKeyByValue(this.select_topic, rowData.topicType),
            serverType: getKeyByValue(this.select_server, rowData.serverType),
            partitionNum: rowData.partitionNum,
            introduce: rowData.introduce,
            id: rowData.id
          }
        } else {
          this.dialogModel = {
            topic: '',
            topicType: '',
            serverType: '',
            partitionNum: '',
            introduce: ''
          }
        }
      },
      e_save (d) {
        let params = new URLSearchParams()
        Object.keys(d).map((item) => {
          params.append(item, d[item])
        })
        params.append('siteCode', this.siteCode)
        if (this.isAmend) {
          topicConfigBiz.updateTopic(params).then((res) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.dialogFormShow = false
              this.search()
            }, 500)
          })
        } else {
          topicConfigBiz.addTopic(params).then((res) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              this.dialogFormShow = false
              this.search()
            }, 500)
          })
        }
      },
      e_delete (rowData) {
        let params = new URLSearchParams()
        params.append('id', rowData.id)
        params.append('siteCode', this.siteCode)
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
          type: 'warning'
        }).then(() => {
          topicConfigBiz.deleteTopic(params).then((data) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.search()
          })
        }).catch(() => {

        })
      },
      e_cancel () {
        this.dialogFormShow = false
      }
    },
    mounted () {},
    watch: {
      'siteCode' () {
        if (this.init) {
          this.init = false
          this.preInitTable()
          this.search()
        } else {
          this.search()
        }
      }
    }
  }
</script>